import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ProfileCard from "@/components/ProfileCard";
import { publicApi } from "@/lib/account";
import useSeo from "@/lib/seo";

export const SEO_CITIES = ["Mumbai", "Delhi", "Bengaluru", "Hyderabad", "Chennai", "Kolkata", "Pune", "Jaipur", "Ahmedabad", "Lucknow", "Kochi", "Chandigarh"];
export const SEO_COMMUNITIES = ["Hindu", "Muslim", "Sikh", "Christian", "Jain"];

export default function CityPage() {
  const { slug } = useParams();
  const city = SEO_CITIES.find((c) => c.toLowerCase() === slug);
  const religion = SEO_COMMUNITIES.find((c) => c.toLowerCase() === slug);
  const label = city || religion || "Indian";
  const [items, setItems] = useState([]);
  useSeo(`${label} Matrimony – Brides & Grooms`, `Find ${label} brides and grooms on Vivaah Royale. Trial from ₹9, chat at ₹1 per message. Create your free profile today.`);
  useEffect(() => {
    if (!city && !religion) return;
    const params = { limit: 24, ...(city ? { city } : {}), ...(religion ? { religion } : {}) };
    publicApi.get("/profiles", { params }).then((r) => setItems(r.data.items));
  }, [city, religion]);
  if (!city && !religion) return <p className="py-32 text-center text-slate-400" data-testid="seo-not-found">Page not found. <Link to="/browse" className="text-amber-300 underline">Browse profiles</Link></p>;
  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14" data-testid="seo-landing-page">
      <p className="text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold">Matrimony</p>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold mt-3" data-testid="seo-landing-title">{label} Matrimony</h1>
      <p className="text-slate-400 mt-4 max-w-2xl">Meet {label} brides and grooms who share your values. Create a free profile, send interests for free, and start chatting from just ₹9 for a 1-day trial.</p>
      <div className="flex gap-3 mt-6">
        <Link to="/me" className="btn-gold px-6 py-3 rounded-full" data-testid="seo-create-profile">Create free profile</Link>
        <Link to="/plans" className="btn-ghost px-6 py-3 rounded-full">See plans</Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
        {items.map((p, i) => <ProfileCard key={p.id} p={p} index={i} />)}
      </div>
    </div>
  );
}
